/**
 * Shared theme utility functions for v2 components
 * Provides a generic merge function to avoid duplication across components
 */

/**
 * Generic theme merge utility that performs shallow merge of theme objects
 * @param baseTheme - The default theme object
 * @param customTheme - Optional custom theme overrides
 * @returns Merged theme object
 */
export function mergeTheme<T extends Record<string, any>>(
  baseTheme: T,
  customTheme?: Partial<T>
): T {
  if (!customTheme) return baseTheme;

  const merged = { ...baseTheme };

  for (const key in customTheme) {
    if (customTheme[key] !== undefined) {
      merged[key] = customTheme[key] as T[Extract<keyof T, string>];
    }
  }

  return merged;
}
